module.exports = __webpack_public_path__ + "img/mail_sent.1cd8da27.svg";